import React from 'react';
import { useTranslation } from '../contexts/LanguageContext';
import { useGameStore } from '../store/gameStore';

export const GameStatus: React.FC = () => {
  const winner = useGameStore((state) => state.winner);
  const gamePhase = useGameStore((state) => state.gamePhase);
  const currentTeam = useGameStore((state) => state.currentTeam);
  const { t } = useTranslation();

  const getStatusMessage = () => {
    if (winner) {
      return winner === 'red' ? t.redTeamWins : t.blueTeamWins;
    }
    if (gamePhase === 'setup') return t.newGame;
    return currentTeam === 'red' ? t.redTeamTurn : t.blueTeamTurn;
  };

  return (
    <div className="status">{getStatusMessage()}</div>
  );
};
